<template>
  <Dialog v-model:visible="visible"  modal :style="dialogStyle"  @hide="onHide">
      <template #header>
        <div ><h3>{{ $t(course.name) }}</h3></div>
       
    </template>
   
     <div >
          <img :src="course.iconUrl"  style="max-width: 200px;float:left;margin-right:1rem;"/>
        
          <p class="value-description" v-html="getDesc(course)"></p>
                
       
    
            
       
        
    </div>
     <template v-if="course.video">
        <div  class="course-vid-container">
            <div class="video-text">{{ $t('Watch the video to get an overview of the course.')}}</div>
           
            <video class="course-vid" controls :poster="course.poster">
                <source
                    :src="course.video"
                    type="video/mp4" />
            </video>  
             
        </div>
    </template>    
    <div class="pricing-header" >
                                              
        <span class="course-price" v-if="course.cdnPrice || course.usPrice">Price:</span>
        <div class="course-pricing">
        
        <span class="course-price" v-if="course.cdnPrice">{{course.cdnPrice}} CAD</span>
        <span class="course-price" v-if="course.usPrice">{{course.usPrice}} USD</span>
        <!-- <span class="course-price" v-if="!course.cdnPrice && !course.usPrice">contact info&commat;invrs.com</span> -->
        </div>
    </div>
   
    <template #footer>
        <div style="text-align:center;">
        <!-- <Button label="Close" text severity="secondary"  @click="onHide" autofocus /> -->
        
        <a class="cta btn" v-if="course.signupCode"   @click="goToSignup(course.signupCode)" >{{$t('Sign Up')}}</a>
        </div>
    </template>
  </Dialog>
</template>

<script>
import { SIGNUP_URL } from "../../config.js";
import Dialog from 'primevue/dialog';

import i18nService from '../../i18n.js';

//import Button from 'primevue/button'

export default {
    name: "CourseInfoModal",
    components:{
        Dialog,
       // Button,
    },
    props:{
        
    },

    data() {
       return {

        visible: false,
        course: null,
       }
    },

    computed: {
        dialogStyle() {
            if( this.course?.video ){
                return "width: 80rem";
            }
            else {
                return 'width: 50rem;'
            }
        }
    },

    methods: {
        getDesc(course){
            return course.description[i18nService.currentLocale];
        },
        goToSignup(courseCode) {
        //evt.preventDefault();
            if( courseCode ){
            window.location.href = SIGNUP_URL+"?courseCode="+courseCode;
            }
            else {
            window.location.href = SIGNUP_URL
            }
        },

         open(course){
            this.course = course;
            this.visible = true;
        },

        onHide() {
            this.visible = false;
            this.course = null;
        },

        getStyle() {

        }
    }


   

    
}
</script>

<style scoped>

 .course-outline{
      margin-top: 1rem;
      margin-left:1rem;
      margin-right:auto;
      text-align: left;
    }

   
.video-text{
    margin: 1rem auto 1rem auto;
    font-size: 1.8rem;
}
.course-vid {
    width: 100%; 
}
.course-vid-container{
    text-align: center;
    width: 100%;
    display:flex;
      flex-direction: column;
      margin-top:5px;
      /*max-width: 30rem;*/
      align-items: baseline;
      align-self: flex-end;
      justify-content: end;

}
 a.cta{
    padding: .8rem 1.3rem;
    align-self: center;
    margin-left:auto;
    font-size: 1.5rem;
  }

 .pricing-header{
      display:flex;
      flex-direction: row;
      margin-top:5px;
      /*max-width: 30rem;*/
      align-items: baseline;
      align-self: flex-end;
      justify-content: end;
    }
.course-price{
      font-size: 1.8rem;
    }
    .course-pricing{
      display:flex;
      flex-direction: column;
      align-items: end;
      margin-left:5px;
    }


.value-description{
    font-size: 1.5rem;
    line-height: 2.6rem;
   

}

.p-button.p-button-secondary{
    border-radius: 8px;
}

.p-button.p-button-secondary.p-button-text{
    color: #33cc99 ;
    font-size: 1.5rem;
}

.p-button.p-button-secondary.p-button-text:enabled:hover{
    color: #33cc99 ;
}

.p-button.p-button-secondary.p-button-outlined {
    color: #5d8679 ;
}
.p-button.p-button-secondary.p-button-outlined:enabled:hover{
    color: #33cc99 ;
}
</style>